var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "modal",
      staticClass: "modal fade",
      attrs: { tabindex: "-1", role: "dialog", "aria-hidden": "true" }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-xl modal-dialog-scrollable",
          attrs: { role: "document" }
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("h5", { staticClass: "modal-title" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "testEquipment.measurementSpecificationTemplate.editModal.title"
                    )
                  )
                )
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: { type: "button", "aria-label": "Close" },
                  on: { click: _vm.dismiss }
                },
                [
                  _c("span", { attrs: { "aria-hidden": "true" } }, [
                    _vm._v("×")
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _vm.template
              ? _c(
                  "div",
                  { staticClass: "modal-body" },
                  [
                    _c("MeasurementSpecificationTemplateEditor", {
                      attrs: { template: _vm.template, editable: _vm.editable }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  attrs: { type: "button" },
                  on: { click: _vm.dismiss }
                },
                [_vm._v(_vm._s(_vm.$t("btnClose")))]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  attrs: {
                    type: "button",
                    disabled: !_vm.canSave || _vm.saving
                  },
                  on: { click: _vm.save }
                },
                [
                  _vm.saving
                    ? _c("Spinner", { attrs: { small: true } })
                    : _vm._e(),
                  _vm._v(
                    "\n          " + _vm._s(_vm.$t("btnSave")) + "\n        "
                  )
                ],
                1
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }